import React from 'react';

type EditIconProps = {
  className?: string;
  onClick?: () => void;
  size?: number;
  color?: string | undefined;
  strokeWidth?: number
};

const NewYoutubeIcon = ({ color = '#FF0302', size = 20, strokeWidth = 1.2, className, onClick }: EditIconProps) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_188_10594)">
      <path d="M19.6014 5.1541C19.4883 4.72861 19.2654 4.34029 18.9551 4.02798C18.6448 3.71568 18.2579 3.49035 17.8332 3.37456C16.2695 2.9541 10.0195 2.9541 10.0195 2.9541C10.0195 2.9541 3.76953 2.9541 2.20589 3.37456C1.78114 3.49035 1.39425 3.71568 1.08394 4.02798C0.773628 4.34029 0.550786 4.72861 0.437713 5.1541C0.0195313 6.72456 0.0195312 9.99956 0.0195312 9.99956C0.0195312 9.99956 0.0195313 13.2746 0.437713 14.845C0.550786 15.2705 0.773628 15.6588 1.08394 15.9711C1.39425 16.2834 1.78114 16.5088 2.20589 16.6246C3.76953 17.045 10.0195 17.045 10.0195 17.045C10.0195 17.045 16.2695 17.045 17.8332 16.6246C18.2579 16.5088 18.6448 16.2834 18.9551 15.9711C19.2654 15.6588 19.4883 15.2705 19.6014 14.845C20.0195 13.2746 20.0195 9.99956 20.0195 9.99956C20.0195 9.99956 20.0195 6.72456 19.6014 5.1541Z" fill={color} />
      <path d="M7.97461 12.9741V7.02637L13.2019 10.0002L7.97461 12.9741Z" fill="#FEFEFE" />
    </g>
    <defs>
      <clipPath id="clip0_188_10594">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>


);

export default NewYoutubeIcon;